import React from "react";
import { Link } from "gatsby"
import ContentModule from "../../../modules/content_module";

import NewsletterForm from "../../forms/newsletter-form";

const FooterSubscribe = ({data}) => {

    return (

        <div className="newsletter d-none d-md-block" id="footer_subscribe">
            <h5>{data.title}</h5>

            {data?.content && <ContentModule Content={data?.content} />}

            <div className="form-wrap">
                <div className="newsletter_form">
                    <div className="box-wrap">
                        {/* <input type="text" placeholder="Full Name"></input>

                        <input type="text" placeholder="Your Email"></input>
                        <button type="submit" className="btn ">Submit</button> */}
                        <NewsletterForm />
                    </div>

                    <div className="info-text">                        
                        {data?.form_bottom_content && <ContentModule Content={data?.form_bottom_content} />}
                    </div>

                </div>
            </div>
        </div>
    )
}
export default FooterSubscribe;